if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.submitButton = this.querySelector('[type="submit"]');
      this.cart = document.querySelector('cart-drawer');
      this.hideErrors = this.dataset.hideErrors === 'true';
      this.requiresCapSize = this.dataset.requiresCapSize === 'true';
      if (this.requiresCapSize) this.setupCapSize();
    }

    // Roché: wigs need a cap size. The select sits outside the form tag but is tied to it with the form attribute.
    getCapSelect() {
      // getAttribute on purpose: form.id is shadowed by the hidden input named "id"
      const formId = this.form && this.form.getAttribute('id');
      if (!formId) return null;
      return document.querySelector(`select[data-roche-cap-select][form="${formId}"]`);
    }

    capSizeMissing() {
      if (!this.requiresCapSize) return false;
      const select = this.getCapSelect();
      return !select || !select.value;
    }

    showCapError(show) {
      const select = this.getCapSelect();
      if (!select) {
        // No selector on this surface (for example a quick form): send the customer to the product page
        if (show) this.handleErrorMessage('Please choose your cap size on the product page.');
        return;
      }
      const wrap = select.closest('[data-roche-cap-size]');
      const error = wrap && wrap.querySelector('.roche-cap-size__error');
      if (wrap) wrap.classList.toggle('is-invalid', show);
      if (error) error.hidden = !show;
      select.setAttribute('aria-invalid', show ? 'true' : 'false');
      if (show) {
        select.focus();
        if (wrap && wrap.scrollIntoView) wrap.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
    }

    setupCapSize() {
      const sync = () => {
        const missing = this.capSizeMissing();
        this.classList.toggle('roche-cap-missing', missing);
        if (!missing) this.showCapError(false);
      };
      document.addEventListener('change', (evt) => {
        const t = evt.target;
        if (t && t.matches && t.matches('select[data-roche-cap-select]') && t.getAttribute('form') === this.form.getAttribute('id')) sync();
      });
      sync();
      // Fast checkout buttons (Shop Pay, Apple Pay) skip our submit handler, so stop their click here
      this.addEventListener('click', (evt) => {
        if (!evt.target.closest('.shopify-payment-button')) return;
        if (!this.capSizeMissing()) return;
        evt.preventDefault();
        evt.stopPropagation();
        evt.stopImmediatePropagation();
        this.showCapError(true);
      }, true);
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('disabled') === 'true') return;
      if (this.capSizeMissing()) {
        this.showCapError(true);
        return;
      }
      this.handleErrorMessage();
      this.submitButton.setAttribute('disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading--spinner')?.classList.remove('hidden');
      this.submitButton.querySelector('[data-add-to-cart-text]').classList.add('hidden');
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
      
      }
      config.body = formData;
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);
            this.submitButton.setAttribute('disabled', true);
            this.error = true;
             const drawerSelector = document.querySelector("#quickView-drawer");
             setTimeout(() => {
              //focusElement = event.target;
              trapFocusElements(drawerSelector);
          }, 500);
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }
          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;
          if(this.cart){
            if(document.querySelector(".product-sticky-bar")){
              document.querySelector(".product-sticky-bar").classList.remove("is-visible")
            }
            this.cart.renderContents(response);
            this.cart.classList.add("is-visible");
            focusElement = this.submitButton;
            document.querySelector("body").classList.add("overflow-hidden");
          
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          this.submitButton.querySelector('[data-add-to-cart-text]').classList.remove('hidden');
          if (this.cart && this.cart.classList.contains('is-empty'))
          this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('disabled');
          this.querySelector('.loading--spinner')?.classList.add('hidden');
       
        });
    }

    handleErrorMessage(errorMessage = false) {
     if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form--error-message-wrapper') || this.closest("product-card").querySelector('.product-form--error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form--error-message') || this.closest("product-card").querySelector('.product-form--error-message-wrapper');
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}